import { render, staticRenderFns } from "./supplier-costModification-popup.vue?vue&type=template&id=2daabf81"
import script from "./supplier-costModification-popup.vue?vue&type=script&lang=js"
export * from "./supplier-costModification-popup.vue?vue&type=script&lang=js"
import style0 from "./supplier-costModification-popup.vue?vue&type=style&index=0&id=2daabf81&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports